export enum PartSchemas {
  core = 'core',
  alts = 'alts',
  specs = 'specs',
  supply = 'supply',
  market = 'market',
}

export enum partStatusRequestTypes {
  REQUESTING = 'requesting',
  READY = 'ready',
  FETCHING = 'fetching',
  SUCCESS = 'success',
  ERROR = 'error',
}

export type PartRequestStateType = {
  [PartSchemas.core]: partStatusRequestTypes | null;
  [PartSchemas.alts]: partStatusRequestTypes | null;
  [PartSchemas.specs]: partStatusRequestTypes | null;
  [PartSchemas.supply]: partStatusRequestTypes | null;
  [PartSchemas.market]: partStatusRequestTypes | null;
};

export const DefaultPartRequestState = {
  [PartSchemas.core]: null,
  [PartSchemas.alts]: null,
  [PartSchemas.specs]: null,
  [PartSchemas.supply]: null,
  [PartSchemas.market]: null,
} as PartRequestStateType;
